<script setup>
import { computed } from "vue";

const props = defineProps({
  label: { type: String, required: true },
  value: { type: String, required: true },
  hint: { type: String, default: "" },
  accent: { type: String, default: "#2a78d6" },
  delta: { type: Object, default: null },
  goodWhen: { type: String, default: "up" },
});

const DELTA_ICONS = {
  up: "fa-caret-up",
  new: "fa-caret-up",
  down: "fa-caret-down",
  flat: "fa-minus",
};

const deltaTone = computed(() => {
  const direction = props.delta?.direction;
  if (!direction || direction === "flat") return "neutral";
  const isIncrease = direction === "up" || direction === "new";
  return isIncrease === (props.goodWhen === "up") ? "positive" : "negative";
});

const deltaIcon = computed(() => DELTA_ICONS[props.delta?.direction] || "");
</script>

<template>
  <div class="card ad-stat-card h-100" :style="{ '--accent': accent }">
    <div class="card-body p-3">
      <div class="ad-stat-label">{{ label }}</div>
      <div class="ad-stat-value">{{ value }}</div>
      <div class="d-flex align-items-center flex-wrap gap-2 mt-2">
        <span v-if="delta" class="ad-stat-delta" :class="`is-${deltaTone}`">
          <i class="fas" :class="deltaIcon"></i>
          {{ delta.label }}
        </span>
        <span v-if="hint" class="ad-stat-hint">{{ hint }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.ad-stat-card {
  border-top: 3px solid var(--accent);
}

.ad-stat-label {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #8898aa;
}

.ad-stat-value {
  margin-top: 0.35rem;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.15;
  color: #344767;
  font-variant-numeric: tabular-nums;
}

.ad-stat-delta {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.1rem 0.45rem;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 700;
}

.ad-stat-delta.is-positive {
  color: #1a8d5f;
  background: rgba(45, 206, 137, 0.14);
}

.ad-stat-delta.is-negative {
  color: #c4322f;
  background: rgba(245, 54, 92, 0.12);
}

.ad-stat-delta.is-neutral {
  color: #67748e;
  background: rgba(103, 116, 142, 0.12);
}

.ad-stat-hint {
  font-size: 0.7rem;
  color: #8898aa;
}
</style>
